<template>
  <div class="header-container">
    <el-breadcrumb separator="/" class="bread-list">
    <el-breadcrumb-item> {{$route.meta.title}}</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{ path: item.path}"
        v-for="(item, index) in breadcrumb"
        :key="index">{{item.name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
  data () {
    return {
      breadcrumb: []
    }
  },
  created () {
    this.breadcrumbs()
  },
  methods: {
    breadcrumbs () {
      if (this.$route.path.indexOf('/orderAddDevice/') !== -1) {
        let order_id = this.$route.params.order_id
        this.$route.meta.breadcrumb[0].path = `/orderAddDevice/${order_id}`
      }
      this.breadcrumb =  this.$route.meta.breadcrumb
    }
  },
  watch: {
    '$route': 'breadcrumbs'
  }
}
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  .header-container
    width:100%;
    height:3rem;
    /* background:#EFF2F7; */
    padding:0 1rem;
    display: flex;
    align-items: center;
    justify-content:space-between;
    .dropdown-container
      .avator
        width:1.6rem;
        height:1.6rem;
        border-radius:50%;
</style>
